module.exports = __webpack_public_path__ + "img/55.dd48c969.jpg";